import { render, staticRenderFns } from "./table-sign.vue?vue&type=template&id=d3e88264&"
import script from "./table-sign.vue?vue&type=script&lang=ts&"
export * from "./table-sign.vue?vue&type=script&lang=ts&"
import style0 from "./table-sign.vue?vue&type=style&index=0&id=d3e88264&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports